var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal new-modal",
      "height": "auto",
      "name": "startOverModal",
      "width": "90%",
      "clickToClose": false,
      "aria-label": _vm.translations.startOverHeader
    },
    on: {
      "beforeOpen": _vm.beforeOpenModal
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-wrapper customs-tools",
    attrs: {
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "headerImg": true
    },
    on: {
      "closeEvent": _vm.closeAction
    }
  }), _c('CustomContainer', {
    staticClass: "new-modal-main-views-wrapper",
    attrs: {
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "new-modal-title",
      "elementType": "h2",
      "text": _vm.translations.startOverHeader
    }
  }), _c('CustomContainer', {
    staticClass: "content modals-start-over"
  }, [_vm.enableStartOverModal ? _c('CustomContainer', [_c('CustomContainer', {
    staticClass: "row"
  }, [_c('CustomText', {
    staticClass: "new-modal-description"
  }, [_c('template', {
    slot: "child"
  }, [_vm._v("\n                    " + _vm._s(this.translations.startOverDescription1) + "\n                  "), _c('br'), _vm._v("\n                  " + _vm._s(this.translations.startOverDescription2) + "\n              ")])], 2)], 1), _c('CustomContainer', {
    staticClass: "row"
  }, [_c('CustomImage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageUrl && !_vm.showSpinner,
      expression: "imageUrl && !showSpinner"
    }],
    attrs: {
      "src": _vm.imageUrl
    },
    on: {
      "load": function load($event) {
        return _vm.hideSpinner(true);
      }
    }
  })], 1), _c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }]
  })], 1) : _c('CustomContainer', [_c('CustomContainer', {
    staticClass: "text-center subheader"
  }, [_c('CustomText', {
    attrs: {
      "elementType": "p",
      "text": _vm.translations.startOverSubHeader1
    }
  }), _c('CustomText', {
    attrs: {
      "elementType": "p",
      "text": _vm.translations.startOverSubHeader2
    }
  })], 1), _c('CustomContainer', {
    staticClass: "modal-img-wrapper modals-start-over-wrapper",
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomImage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageUrl && !_vm.showSpinner,
      expression: "imageUrl && !showSpinner"
    }],
    attrs: {
      "customClass": "modals-start-over-wrapper-img",
      "src": _vm.imageUrl
    },
    on: {
      "load": function load($event) {
        return _vm.hideSpinner(true);
      }
    }
  })], 1), _c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }]
  })], 1)], 1)], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav"
  }, [_c('CustomButton', {
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded secondary",
      "type": "button",
      "keyTranslation": "startOverNo"
    },
    on: {
      "click": function click($event) {
        return _vm.ctaSecondaryAction();
      }
    }
  }), _c('CustomButton', {
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded primary",
      "type": "button",
      "keyTranslation": "startOverAccept"
    },
    on: {
      "click": function click($event) {
        return _vm.ctaPrimaryAction();
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }